module.exports = __webpack_public_path__ + "img/视频场景_小视频.129ddb4e.png";